import Image from '../common/image';

const advantages = {
	path: '/advantages',
	name: 'Advantages',
	title: 'MMP WORLD Advantages',
	content: (theme) => (
		<div className='container py-5'>
			<div className='row'>
				<div className='col-12'>
					<div
						id='safe'
						className='row align-items-center mb-4'>
						<div className='col-sm-3 text-center mb-5'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/safe.svg`}
							/>
							<h2 className='text-set5'>
								<b>SAFE AND STABLE</b>
							</h2>
						</div>
						<div className='col-sm-9'>
							<p>
								Whether you're a seasoned trader or just entering the world of
								cryptocurrency, the MMP Global Market Maker Plan is designed to help
								you achieve your financial goals securely and confidently.
							</p>
							<p>
								MMP WORLD utilizes open-source smart contract technology to ensure
								transparent, stable, and seamless financial transactions. To enhance
								the safety of user funds, the platform integrates:
							</p>
							<ul>
								<li>Hot and cold wallets</li>
								<li>Offline private key storage</li>
								<li>Advanced risk isolation systems</li>
								<li>Two-step verification (Email & Google)</li>
								<li>Remote login alerts</li>
								<li>Automated withdrawal system with manual review</li>
							</ul>
							<p>
								This robust security infrastructure offers users peace of mind and
								full protection of their digital assets. Whether you are an
								individual or an institution, MMP WORLD delivers secure and reliable
								investment solutions tailored to your needs.
							</p>
						</div>
					</div>

					<div
						id='fast'
						className='row align-items-center mb-4'>
						<div className='col-sm-3 text-center mb-5 d-block d-sm-none'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/speed.svg`}
							/>
							<h2 className='text-set5'>
								<b>FAST AND EFFICIENT</b>
							</h2>
						</div>
						<div className='col-sm-9'>
							<p>
								Time is money—and MMP WORLD is built to respect both. Our platform
								offers 24/7 availability for deposits and withdrawals, empowering
								users to manage their portfolios on their own schedule, without
								delays or limitations.
							</p>
							<p>
								Thanks to our automated processing systems, every transaction is
								executed quickly and without interruptions. Coupled with high-level
								security protocols and real-time risk monitoring, users benefit
								from:
							</p>
							<ul>
								<li>Seamless operations around the clock</li>
								<li>Instant fund accessibility</li>
								<li>Secure processing of deposits and withdrawals</li>
								<li>Real-time alerts to prevent unauthorized access</li>
							</ul>
							<p>
								Whether you're managing a long-term portfolio or making active
								trades, MMP WORLD ensures speed, safety, and reliability every step
								of the way.
							</p>
						</div>
						<div className='col-sm-3 text-center mb-5 d-none d-sm-block'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/speed.svg`}
							/>
							<h2 className='text-set5'>
								<b>FAST AND EFFICIENT</b>
							</h2>
						</div>
					</div>

					<div
						id='features'
						className='row align-items-center mb-4'>
						<div className='col-sm-3 text-center mb-5'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/features.svg`}
							/>
							<h2 className='text-set5'>
								<b>PERFECT FEATURES</b>
							</h2>
						</div>
						<div className='col-sm-9'>
							<p>
								MMP WORLD is more than just an investment platform—it’s an entire
								crypto-financial ecosystem designed to meet the evolving needs of
								today’s investors. Our ecosystem includes:
							</p>
							<ul>
								<li>
									Investment Plans: Earn passive income through structured,
									reward-based investment packages
								</li>
								<li>
									Liquidity Pool: Access fast crypto swaps with high liquidity and
									optimal market rates
								</li>
								<li>
									Lending Platform: Borrow or lend crypto and fiat with
									competitive interest rates and streamlined application processes
								</li>
								<li>
									NFT Marketplace: Collect, trade, and invest in unique digital
									assets on our integrated NFT platform
								</li>
								<li>
									Crypto Store: Use your crypto to purchase real-world products
									and services
								</li>
								<li>
									Stock Market Gateway: Invest in traditional stocks using
									cryptocurrency
								</li>
							</ul>
							<p>
								Every project within MMP WORLD complements the others, working
								together to create a unified and dynamic ecosystem where users can
								diversify their financial activities.
							</p>
						</div>
					</div>

					<div
						id='powerfull'
						className='row align-items-center mb-4'>
						<div className='col-sm-3 text-center mb-5 d-block d-sm-none'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/powerfull.svg`}
							/>
							<h2 className='text-set5'>
								<b>POWERFUL OPERATING SYSTEM</b>
							</h2>
						</div>
						<div className='col-sm-9'>
							<p>
								At MMP WORLD, our strength lies not only in our technology but in
								our unwavering commitment to investor trust. We’ve built a powerful,
								decentralized financial infrastructure backed by:
							</p>
							<ul>
								<li>24/7 global support, staffed by experienced professionals</li>
								<li>
									A resilient and scalable backend, designed to handle thousands
									of transactions simultaneously
								</li>
								<li>
									Ongoing development and security updates to stay ahead of
									industry threats
								</li>
								<li>
									Community-driven governance, giving users a voice in platform
									evolution
								</li>
							</ul>
							<p>
								Our systems are engineered to deliver uninterrupted service,
								high-level security, and long-term sustainability. With MMP WORLD,
								you're not just investing—you’re building a future on a foundation
								of trust, transparency, and technological excellence.
							</p>
						</div>
						<div className='col-sm-3 text-center mb-5 d-none d-sm-block'>
							<Image
								className='mb-3'
								height='80px'
								fileName={`home/icons_${theme}/powerfull.svg`}
							/>
							<h2 className='text-set5'>
								<b>POWERFUL OPERATING SYSTEM</b>
							</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	),
};

export default advantages;
